import { colors, fonts } from '../../../theme';

// Same sizes as the app (in % of the width, like its wp()). The bottom of the column is the
// bottom of the info line of the footer.
const ROUND_SIZE = '9.2vw';
const GAME_SIZE = '10.63vw';
const ICON_SIZE = '5.6vw';
const GAP = '2.88vw';

const column = {
  position: 'absolute',
  right: '1.9vw',
  bottom: '3vw',
  width: '12vw',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: GAP,
  // Above the gradient of the footer.
  zIndex: 11,
};

const styles = {
  column,
  // The TikTok browser on iOS covers the bottom of the page.
  columnTiktok: {
    ...column,
    bottom: 'calc(3vw + 12px)',
  },
  // No round background, like the app: white with a soft shadow, readable on any video.
  action: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.71vw',
    color: colors.text,
    fontSize: ICON_SIZE,
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55))',
    '& svg': {
      display: 'block',
      width: '1em',
      height: '1em',
    },
  },
  count: {
    fontFamily: fonts.text,
    fontSize: '2.82vw',
    fontWeight: 600,
    lineHeight: 1.2,
    color: colors.text,
  },
  // The "+" overlaps the bottom of the avatar.
  // The next gap starts under the "+".
  creator: {
    position: 'relative',
    flexShrink: 0,
    mb: '9px',
  },
  avatar: {
    width: ROUND_SIZE,
    height: ROUND_SIZE,
    border: `2px solid ${colors.text}`,
  },
  follow: {
    position: 'absolute',
    left: '50%',
    bottom: -8,
    transform: 'translateX(-50%)',
    width: 18,
    height: 18,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.text,
    color: colors.background,
    '& svg': {
      fontSize: 14,
    },
  },
  gameButton: {
    flexShrink: 0,
    mt: '0.32vw',
    filter: 'drop-shadow(0 1px 3px rgba(0, 0, 0, 0.6))',
  },
  game: {
    display: 'block',
    width: GAME_SIZE,
    height: GAME_SIZE,
    objectFit: 'contain',
  },
};

export default styles;
